import React from "react";
import { Box, Typography, Divider, LinearProgress, Chip } from "@mui/material";
import { Web } from "@mui/icons-material";

const AccountStatsCard = ({ stats, plan, usage }) => {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        height: "100%",
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Web sx={{ color: "primary.main" }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Account Statistics
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />

      {/* Current Plan */}
      {plan && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Current Plan
          </Typography>
          <Chip
            label={plan.name}
            color={plan.name === "Free" ? "default" : "success"}
            size="small"
          />
        </Box>
      )}

      {/* Sites Usage */}
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
          <Typography variant="body2" fontWeight={500}>
            Sites: {usage?.sitesUsed ?? stats?.totalSites ?? 0} /{" "}
            {usage?.sitesLimit ?? "∞"}
          </Typography>
          {usage?.sitesPercentage != null && (
            <Typography variant="body2" color="text.secondary">
              {usage.sitesPercentage}%
            </Typography>
          )}
        </Box>
        {usage?.sitesPercentage != null && (
          <LinearProgress
            variant="determinate"
            value={Math.min(usage.sitesPercentage, 100)}
            color={
              usage.sitesPercentage >= 90
                ? "error"
                : usage.sitesPercentage >= 70
                  ? "warning"
                  : "primary"
            }
            sx={{ height: 6, borderRadius: 3 }}
          />
        )}
      </Box>

      {/* Storage Usage */}
      {usage?.storageLimitGB != null && (
        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="body2" fontWeight={500}>
              Storage: {usage.storageUsedGB ?? 0} GB / {usage.storageLimitGB} GB
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {usage.storagePercentage ?? 0}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={Math.min(usage.storagePercentage ?? 0, 100)}
            color={
              (usage.storagePercentage ?? 0) >= 90
                ? "error"
                : (usage.storagePercentage ?? 0) >= 70
                  ? "warning"
                  : "primary"
            }
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AccountStatsCard;
